<template>
  <div class="pos-fnb-container">
    <posFnBHeader />
    <section class="pos-fnb-center-view">
      <div class="row h-100">
        <div class="col-lg-9 col-xl-9 col-md-8 col-sm-8">
          <div v-if="FnBItemsModule" class="pos-fnb-search-wrapper">
            <form
              v-on:submit.prevent.self="fetchFnBItems"
              class="pos-fnb-searchbar"
            >
              <input
                :value="fnbSearch"
                type="text"
                id="boxofficeSearch"
                @input="setOnFnBPayloads({ event: $event, name: 'search' }); fetchFnBItems();"
                placeholder="Search for Food Items"
              />
              <div
                v-if="fnbSearch.length > 0"
                style="width: 50px"
                class="pos-fnb-clearSearch"
                @click="
                  setOnFnBPayloads({ event: $event, name: 'clearsearch' })
                "
              >
                &times;
              </div>
              <input type="submit" value />
              <VkeyboardFloat
                :ID="'boxofficeSearch'"
                :onClickFun="
                  () => {
                    Object.keys(keyboardsVisible).map(x => {
                      if (x == 'showFnbSearchKeyboard') {
                        keyboardsVisible[x] = !keyboardsVisible[x];
                      } else {
                        keyboardsVisible[x] = false;
                      }
                    });
                  }
                "
              />
              <Vkeyboard
                :inputName="'boxofficeSearch'"
                :showOrHide="keyboardsVisible.showFnbSearchKeyboard"
                :initialValue="fnbSearch"
                @onChangeEvent="() => {}"
                @onKeyEnter="fetchFnBItems()"
                @changeKeyboardInput="
                  event => {
                    fnbSearch = event;
                    setOnFnBPayloads({
                      event: {
                        target: {
                          value: event
                        }
                      },
                      name: 'search'
                    });
                  }
                "
                @onClickClose="
                  () => {
                    keyboardsVisible.showFnbSearchKeyboard = false;
                  }
                "
              />
            </form>

            <button
              :class="[
                'btn-pos-fnb-filter ml-3 ',
                { invisible: fnbSubSubCategories.length == 0 }
              ]"
              v-b-modal.filterFnbItems
            ></button>

            <div class="d-flex align-items-center pl-3 switch-success">
              <!-- value-field -->
              <b-form-checkbox
                unchecked-value="N"
                button-variant="info"
                value="Y"
                name="check-button"
                @input="setOnFnBPayloads({ event: $event, name: 'isVeg' })"
                switch
              ></b-form-checkbox>
              <!-- @input="onIsVegChange({ event: $event,})" -->
              <label class="text-nowrap ml-3 mb-0 text-success">Veg Only</label>
            </div>

            <div
              v-if="isVeg === 'Y'"
              class="d-flex align-items-center pl-3 switch-warning"
            >
              <b-form-checkbox
                unchecked-value="N"
                value="Y"
                name="check-button"
                @input="setOnFnBPayloads({ event: $event, name: 'isEgg' })"
                switch
              ></b-form-checkbox>
              <label class="text-nowrap ml-3 mb-0">Contains Egg</label>
            </div>
            <!-- <button class="btn-pos-fnb-scan"></button> -->
          </div>

          <div :class="[FnBItemsModule ? 'pos-fnb-components-container' : '']">
            <div v-if="isFnbDataLoading && FnBItemsModule" class="pos-fnb-item-not-found">
              <div>
                <div>
                  <img
                    src="@/assets/img/icons/loading.svg"
                    height="75"
                    width="75"
                  />
                </div>
                <h6 class="pt-3 mb-2">Loading...</h6>
                <h6>Fetching Fnb Items...Please Wait</h6>
              </div>
            </div>

            <div v-if="!fnbItems" class="pos-fnb-item-not-found">
              <div>
                <div>
                  <img
                    src="@/assets/img/icons/pos-fnb-no-itmes.svg"
                    height="75"
                    width="75"
                  />
                </div>
                <h6 class="pt-3 mb-2">Opps!</h6>
                <h6>No Items Found!</h6>
              </div>
            </div>
            <PosFnbPopcorn v-if="FnBItemsModule" :foodItems="fnbItems || []" />
            <PosFnbCheckout v-if="!FnBItemsModule" />
            <BoxOfficeFnbFinalTicket
              v-if="showFnBOrderDetails"
              :onNumberSubmit="OnPhoneNumberSubmitHandler"
              :onClickHandler="onSwtichModule"
              :itemsList="SelectedFnbItemList"
              :taxesTotal="TotalAdditionalTaxes"
              :taxes="AdditionalTaxList"
              :subTotal="selectedFnBItemsTotalPrice"
              :currency="getFnBCurrency.curr_code"
              :onPrintCall="GoToRoute"
              :printText="printText"
            />
          </div>
        </div>

        <!-- RIGHT TOTAL PANEL -->
        <div class="col-lg-3 col-xl-3 pl-0 col-md-4 col-sm-4">
          <div class="pos-fnb-summary-box">
            <header class="summary-header">
              <!-- <button class="btn-pos-fnb-add-on" @click="onClickAddOnButton()">
                Add-Ons
              </button> -->
              <!-- <button
                class="btn-pos-fnb-view-offers"
                v-b-modal.pos-applicable-offers
              >
                View Offers
              </button> -->
              <div class="col-12" v-if="getCustomerDetails.first_name">
                <div class="row border-bottom-lightgrey py-2">
                  <div class="col-5">
                    <span class="text-lightgrey">{{ $tc("customer", 1) }}</span>
                  </div>
                  <div class="col-7 px-0 overflow-hidden">
                    <strong
                      >{{ getCustomerDetails.first_name }}
                      {{ getCustomerDetails.last_name }}</strong
                    >
                  </div>
                </div>
              </div>
              <div class="col-12 py-2">
                <div class="row">
                  <div class="col-4">
                    <span class="text-lightgrey">{{ $t("items") }}</span>
                  </div>
                  <div class="col-4 px-0 text-center">
                    <span class="text-lightgrey">Qty</span>
                  </div>
                  <div class="col-4 text-right">
                    <span class="text-lightgrey pr-4 mr-2">{{
                      $tc("price", 1)
                    }}</span>
                  </div>
                  <!-- v-if="showViewOffers" -->
                </div>
              </div>
            </header>

            <div class="summary-content summary-content-height">
              <div
                class="col-12"
                v-for="(orders, index) in SelectedFnbItemList"
                :key="orders.recipe_name + index"
              >
                <div class="row align-items-center py-2">
                  <div :class="windowWidth <= 1024 ? 'col-5 pl-2' : 'col-4 pl-2'"
                  class="font_size_12"
                  >
                    <div>
                      <small class="font-weight-bold">{{
                        orders.item_name
                      }}</small>
                      <p
                        class="fs-14 text-blue mb-0 c-pointer click-anim"
                        @click="
                          onFetchCustomization({
                            item_id: orders.item_id,
                            customization_common_id:
                              orders.customization_common_id
                          })
                        "
                        v-if="
                          orders.is_customization_available &&
                            orders.is_customization_available == 'Y'
                        "
                      >
                        (customise)
                      </p>
                      <p
                        @click="
                          onFetchAlternateItems({
                            item_id: orders.item_id,
                            index: index,
                            quantity: orders.quantity
                          })
                        "
                        class="fs-14 text-blue mb-0 c-pointer click-anim"
                        v-if="
                          orders.has_alternate_items &&
                            orders.has_alternate_items == 'Y'
                        "
                      >
                        (Alternate)
                      </p>
                    </div>
                  </div>
                  <div
                    class="
                      col-4
                      px-0
                      d-flex
                      align-items-center
                      justify-content-between
                    "
                  >
                    <button
                      class="btn-pos-subtract"
                      :class="
                        orders.Qty < 2
                          ? 'opacity-50'
                          : orders.hasOwnProperty('item_is_compulsory') &&
                            orders.item_is_compulsory == 'Y' &&
                            false
                          ? 'pointer-events'
                          : ''
                      "
                      :disabled="
                        orders.hasOwnProperty('item_is_compulsory') &&
                          orders.item_is_compulsory == 'Y' &&
                          selectedSeats.length == orders.quantity
                      "
                      v-on:click="
                        onDecreaseFnBItem({ index });
                        applyBoxOfficeFnbOffersHandler({
                          event: $event,
                          offer: getSelectedOffer,
                          offerFor: getOfferFor
                        });
                        onEmitSocket();
                      "
                    >
                      &minus;
                    </button>
                    <strong>{{ orders.quantity }}</strong>
                    <button
                      class="btn-pos-add"
                      v-on:click="
                        onIncreaseFnBItem({ index });
                        applyBoxOfficeFnbOffersHandler({
                          event: $event,
                          offer: getSelectedOffer,
                          offerFor: getOfferFor
                        });
                        onEmitSocket();
                      "
                    >
                      +
                    </button>
                  </div>
                  <div :class="windowWidth <= 1024 ? 'col-3' : 'col-4'">
                    <div
                      class="
                        d-flex
                        w-100
                        align-items-center
                        justify-content-between
                      "
                    >
                      <strong>{{ orders.fp_total_amount }}</strong>
                      <button
                        class="btn-pos-delete"
                        v-if="
                          !orders.hasOwnProperty('item_is_compulsory') ||
                            orders.item_is_compulsory == 'N'
                        "
                        v-on:click="
                          onRemoveFnBList({ index });
                          applyBoxOfficeFnbOffersHandler({
                            event: $event,
                            offer: getSelectedOffer,
                            offerFor: getOfferFor
                          });
                          onEmitSocket();
                        "
                      ></button>
                    </div>
                  </div>
                  <div
                    class="col-12 pt-2"
                    v-if="
                      orders.hasOwnProperty('customizations') &&
                        orders['customizations'].length > 0
                    "
                  >
                    <div class="row">
                      <div class="col-12 align-self-center">
                        <div
                          class="my-1 row"
                          v-for="(singleCustomItem,
                          singleCustomItemIndex) in orders['customizations']"
                          :key="singleCustomItemIndex"
                        >
                          <span class="text-muted col-10">{{
                            singleCustomItem.item_name
                          }}</span>
                          <div class="col-2">
                            <span
                              class="icon-delete cursor-pointer"
                              v-on:click="
                                onRemoveCustomization({
                                  item_id: orders.item_id,
                                  customization_id:
                                    orders.customizations[0].item_id
                                })
                              "
                              v-if="
                                orders.hasOwnProperty('customizations') &&
                                  orders['customizations'].length > 0
                              "
                            ></span>
                          </div>
                        </div>
                      </div>
                      <!-- <div class="col-4">
                        <button
                          class="btn-outline-blue btn-sm mw-auto mx-0 w-100"
                          @click="
                            onFetchCustomization({
                              item_id: orders.item_id,
                              customization_common_id:
                                orders.customization_common_id
                            })
                          "
                          v-if="
                            orders.is_customization_available &&
                              orders.is_customization_available == 'Y'
                          "
                        >
                          Edit
                        </button>
                      </div> -->
                    </div>
                  </div>
                  <div
                    class="col-12 pt-2"
                    v-if="
                      orders.hasOwnProperty('is_combo') &&
                        orders.hasOwnProperty('combo_pack') &&
                        orders.is_combo == 'Y' &&
                        orders['combo_pack'].length > 0
                    "
                  >
                    <div class="row">
                      <div class="col-7 align-self-center">
                        <div
                          v-for="(singleCategory,
                          singleCategoryIndex) in orders['combo_pack']"
                          :key="singleCategoryIndex"
                        >
                          <div
                            class="my-1 row justify-content-start"
                            v-for="(comboItem,
                            comboItemIndex) in singleCategory.combo_items"
                            v-if="comboItem.quantity > 0"
                            :key="comboItemIndex"
                          >
                            <span class="text-muted col-9"
                              >{{ comboItem.item_name }}
                            </span>
                            <span class="text-muted col-2"
                              >x{{ comboItem.quantity }}</span
                            >
                          </div>
                        </div>
                      </div>
                      <div class="col-5 align-items-center">
                        <button
                          class="btn-outline-blue btn-sm mw-auto mx-0 w-100 br-20"
                          @click="onCustomizeCombo(orders, index)"
                        >
                          Customise
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <hr class="my-0" />
              </div>
              <!-- ADDONS -->
              <div
                class="col-12"
                v-for="(addon, addOnIndex) in selectedAddons"
                :key="addon.add_on_item_name + addOnIndex"
              >
                <div class="row align-items-center py-2">
                  <div class="col-4 pr-2">
                    <small class="font-weight-bold">{{
                      addon.add_on_item_name
                    }}</small>
                  </div>
                  <div
                    class="
                      col-4
                      px-0
                      d-flex
                      align-items-center
                      justify-content-between
                    "
                  >
                    <button
                      class="btn-pos-subtract"
                      v-on:click="onDecreaseAddonItem({ index: addOnIndex })"
                    >
                      &minus;
                    </button>
                    <strong>{{ addon.quantity }}</strong>
                    <button
                      class="btn-pos-add"
                      v-on:click="onIncreaseAddonItem({ index: addOnIndex })"
                    >
                      +
                    </button>
                  </div>
                  <div class="col-4">
                    <div
                      class="
                        d-flex
                        w-100
                        align-items-center
                        justify-content-between
                      "
                    >
                      <strong>{{
                        (addon.add_on_item_price * addon.quantity) | RoundOff
                      }}</strong>
                      <button
                        class="btn-pos-delete"
                        v-on:click="onRemoveAddonList({ index: addOnIndex })"
                      ></button>
                    </div>
                  </div>
                </div>

                <hr class="my-0" />
              </div>

              <div
                v-if="
                  SelectedFnbItemList.length == 0 && selectedAddons.length == 0
                "
                style="max-height: calc(100% - 95px)"
                class="text-center h-100 d-flex align-items-center"
              >
                <div>
                  <img
                    src="@/assets/img/icons/select-food.png"
                    class="w-50 pb-4"
                    alt
                  />
                  <h5 class="mb-0">
                    Your cart is empty.
                    <br />Add an item to begin.
                  </h5>
                </div>
              </div>

              <div class="col-12 py-1" v-if="SelectedFnbItemList.length > 0">
                <div class="row">
                  <div class="col-4">
                    <span class="text-lightgrey">Sub Total</span>
                  </div>
                  <div class="col-8 text-right">
                    <div>
                      {{ getFnBCurrency.curr_code | uppercase }} &nbsp;{{
                        currFormat(selectedFnBItemsTotalPrice)
                      }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 py-1" v-if="SelectedFnbItemList.length > 0">
                <div v-if="AdditionalTaxList.length == 0" class="row">
                  <div class="col-4">
                    <span class="text-lightgrey">Tax</span>
                  </div>
                  <div class="col-8 text-right">
                    <div>{{ getFnBCurrency.curr_code | uppercase }}&nbsp;0</div>
                  </div>
                </div>
                <!-- CUSTOMIZATIONS -->
                <div
                  class="row"
                  v-if="selectedChargeableCustomizations.length > 0"
                  v-for="(singleItem,
                  singleItemIndex) in selectedChargeableCustomizations"
                  :key="singleItemIndex"
                >
                  <div class="col-5">
                    <span class="text-black">{{ singleItem.item_name }}</span>
                  </div>
                  <div class="col-7 text-right">
                    <strong
                      >{{ getFnBCurrency.curr_code | uppercase }}&nbsp;{{
                        currFormat(singleItem.fp_total_amount)
                      }}</strong
                    >
                  </div>
                </div>
                <div
                  v-if="AdditionalTaxList.length > 0"
                  v-for="(AdditionalTax,
                  AdditionalTaxIndex) in AdditionalTaxList"
                  :key="AdditionalTaxIndex + AdditionalTax.ct_name"
                  class="row"
                >
                  <div class="col-5">
                    <span class="text-lightgrey">{{
                      AdditionalTax.ct_name | uppercase
                    }}</span>
                  </div>
                  <div class="col-7 text-right">
                    <div>
                      {{ getFnBCurrency.curr_code | uppercase }}&nbsp;{{
                        currFormat(AdditionalTax.totalTax)
                      }}
                    </div>
                  </div>
                </div>
              </div>
              <!-- ADDON EXTRA CHARGES -->
              <div class="col-12 py-1" v-if="selectedAddons.length > 0">
                <div v-if="addonsAdditionalCharges.length == 0" class="row">
                  <div class="col-4">
                    <span class="text-lightgrey">Tax</span>
                  </div>
                  <div class="col-8 text-right">
                    <div>{{ getFnBCurrency.curr_code | uppercase }}&nbsp;0</div>
                  </div>
                </div>
                <div
                  v-if="addonsAdditionalCharges.length > 0"
                  v-for="(AdditionalTax,
                  AdditionalTaxIndex) in addonsAdditionalCharges"
                  :key="AdditionalTaxIndex + AdditionalTax.ct_name"
                  class="row"
                >
                  <div class="col-5">
                    <span class="text-lightgrey">{{
                      AdditionalTax.ct_name | uppercase
                    }}</span>
                  </div>
                  <div class="col-7 text-right">
                    <div>
                      {{ getFnBCurrency.curr_code | uppercase }}&nbsp;{{
                        currFormat(AdditionalTax.totalTax)
                      }}
                    </div>
                  </div>
                </div>
              </div>
              <!-- ENDS -->
              <div class="col-12 pt-1">
                <div class="row">
                  <div class="col-5 ">
                    <h6 class="mb-0 font_size_12">{{ $tc("fb") }} {{ $tc("total", 1) }}</h6>
                  </div>
                  <div class="col-7 text-right">
                    <h6 class=" mb-0 font-weight-bold font_size_12">
                      {{ getFnBCurrency.curr_code | uppercase }} &nbsp;{{
                        parseFloat(
                          selectedFnBItemsTotalPrice +
                            TotalAdditionalTaxes +
                            customizationTotalPrice
                        ).toFixed(2)
                      }}
                    </h6>
                  </div>
                </div>
              </div>
              <!-- ADD-ONS-TOTAL -->
              <div class="col-12 py-2">
                <div class="row">
                  <div class="col-6 pr-0">
                    <h6 class="mb-0 font_size_12">
                      {{ $tc("addons") }} {{ $tc("total", 1) }}
                    </h6>
                  </div>
                  <div class="col-6 text-right">
                    <h6 class="mb-0 font-weight-bold font_size_12">
                      {{ getFnBCurrency.curr_code | uppercase }} &nbsp;{{
                        parseFloat(selectedAddonsTotalPrice).toFixed(2)
                      }}
                    </h6>
                  </div>
                </div>
              </div>
              <!-- ENDS -->

              <div class="col-12">
                <hr class="my-0" />
              </div>

              <b-collapse id="showBookingDetails">
                <div class="col-12">
                  <div class="d-flex border-bottom-lightgrey py-2">
                    <div class="col-5 px-0">
                      <span class="text-lightgrey font_size_12">{{ $tc("movie", 1) }}</span>
                    </div>
                    <div class="col-7 pr-0 overflow-hidden">
                      <strong class="font_size_12">{{ showDetails.movie_title }}</strong>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="d-flex border-bottom-lightgrey py-2">
                    <div class="col-5 px-0">
                      <span class="text-lightgrey font_size_12">{{
                        $tc("language", 1)
                      }}</span>
                    </div>
                    <div class="col-7 pr-0">
                      <strong class="font_size_12">{{ showDetails.language_name }}</strong>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="d-flex border-bottom-lightgrey py-2">
                    <div class="col-5 px-0">
                      <span class="text-lightgrey font_size_12">{{ $tc("format", 1) }}</span>
                    </div>
                    <div class="col-7 pr-0">
                      <strong class="font_size_12">{{ showDetails.movie_format }}</strong>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="d-flex border-bottom-lightgrey py-2">
                    <div class="col-5 px-0">
                      <span class="text-lightgrey font_size_12"
                        >{{ $t("time") }} | {{ $t("date") }}</span
                      >
                    </div>
                    <div class="col-7 pr-0">
                      <strong class="font_size_12"
                        >{{ showDetails.ss_start_show_time }} |
                        {{ showDetails.ss_start_date }}</strong
                      >
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="d-flex border-bottom-lightgrey py-2">
                    <div class="col-5 px-0">
                      <span class="text-lightgrey font_size_12">{{ $tc("screen", 1) }}</span>
                    </div>
                    <div class="col-7 pr-0">
                      <strong class="font_size_12">{{ showDetails.screen_name }}</strong>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="d-flex border-bottom-lightgrey py-2">
                    <div class="col-5 px-0">
                      <span class="text-lightgrey font_size_12"
                        >{{ $t("noof") }} {{ $tc("seat", 1) }}</span
                      >
                    </div>
                    <div class="col-7 pr-0">
                      <strong class="font_size_12">{{ selectedSeats.length }}</strong>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="d-flex border-bottom-lightgrey py-2">
                    <div class="col-5 px-0">
                      <span class="text-lightgrey font_size_12"
                        >{{ $tc("seat", 1) }} {{ $t("number") }}</span
                      >
                    </div>
                    <div class="col-7 pr-0">
                      <ul class="pos-selected-seats-list">
                        <li
                          v-for="(seat, seatIndex) in selectedSeats"
                          :key="seatIndex + seat.sl_seat_name"
                          class="font_size_12"
                        >
                          {{ seat.sl_seat_name }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="d-flex border-bottom-lightgrey py-2">
                    <div class="col-5 px-0">
                      <span class="text-lightgrey font_size_12">{{ $t("netAmount") }}</span>
                    </div>
                    <div class="col-7 pr-0">
                      <strong class="font_size_12"
                        >{{ currFormat(netTotal + rateCardAddonsNetAdd()) }}
                        {{ getFnBCurrency.curr_code }}</strong
                      >
                    </div>
                  </div>
                </div>

                <div
                  class="col-12"
                  v-for="(charge, chargeKey) in additionalCharges"
                  :key="chargeKey + charge.ct_name"
                >
                  <div class="d-flex border-bottom-lightgrey py-2">
                    <div class="col-5 pl-0">
                      <span class="text-lightgrey font_size_12">{{ charge.ct_name }}</span>
                    </div>
                    <div class="col-7 pr-0">
                      <strong class="font_size_12">
                        {{ currFormat(charge.sp_value + rateCardAddonsChargeTypeToAdd(charge.charge_type_id)) }}
                        {{ getFnBCurrency.curr_code }}
                        <!-- <span v-if="charge.pas_is_percentage == 'Y'">%</span> -->
                      </strong>
                    </div>
                  </div>
                </div>

                <div class="col-12" v-if="RateCardAddonsChargesFinalAmount">
                  <div class="d-flex border-bottom-lightgrey py-1">
                    <div class="col-5 pl-0">
                      <span class="text-lightgrey font_size_12">{{
                        $t("addon_amount")
                      }}</span>
                    </div>
                    <div class="col-7 pr-0">
                      <strong class="font_size_12"
                        >{{ currFormat(RateCardAddonsChargesFinalAmount) }}
                        {{ getFnBCurrency.curr_code }}</strong
                      >
                      <span
                        class="icon-collapse-up blue-icon mx-1 btn float-right"
                        style="height: 22px!important"
                        v-if="showAddonBreakup"
                        @click="onToggleAddonBreakup()"
                      ></span>
                      <span
                        class="icon-collapse blue-icon mx-1 btn float-right"
                        style="height: 22px!important"
                        v-if="!showAddonBreakup"
                        @click="onToggleAddonBreakup()"
                      ></span>
                    </div>
                  </div>
                </div>
                <b-collapse v-model="showAddonBreakup" class="pb-2 px-4 fs-12">
                  <div
                    v-if="RateCardAddonsChargesList.length > 0"
                    class="col-12"
                    v-for="(rac, racIndex) in RateCardAddonsChargesList"
                    :key="racIndex"
                  >
                    <div class="d-flex border-bottom-lightgrey py-1">
                      <div class="col-5 pl-0">
                        <span class="text-lightgrey font_size_12">{{
                          rac.addons_name
                        }}</span>
                      </div>
                      <div class="col-7 px-0">
                        <strong class="font_size_12"
                          >{{ rac.final_price }}
                          {{ getFnBCurrency.curr_code }}</strong
                        >
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </b-collapse>

              <button
                class="btn-showBookingDetails"
                v-b-toggle.showBookingDetails
                v-on:click="goToTop()"
              >
                <h6 class="mb-0 font_size_12">{{ $t("boxoffice") }} Total</h6>
                <small class="show font_size_12" style="font-size: 10px"
                  >Show Booking Details</small
                >
                <small class="hide font_size_12" style="font-size: 10px"
                  >Hide Booking Details</small
                >
                <div class="showBookingTotal font_size_12">
                  {{ getFnBCurrency.curr_code }}
                  {{ BoxOfficetotalAmount.toFixed(2) }}
                </div>
              </button>
              <div v-if="isLoyaltyApplied" class="col-12">
                <div class="d-flex border-bottom-lightgrey py-2">
                  <div class="col-5 pl-0">
                    <span class="text-lightgrey font_size_12">Loyalty Applied</span>
                    <strong class="font_size_12">{{ LoyaltyProgram }}</strong
                    >&nbsp;
                    <div class="d-flex">
                      <img
                        class="d-table position-relative"
                        src="@/assets/img/icons/question2.svg"
                        v-b-tooltip.hover
                        :title="LoyaltyProgram"
                        height="18"
                        width="18"
                      />
                      <img
                        @click="resetLoyaltyData()"
                        class="d-table position-relative"
                        src="@/assets/img/icons/delete.svg"
                        height="18"
                        width="18"
                      />
                    </div>
                  </div>
                  <div class="col-7 px-0">
                    <strong class="d-block text-right"
                      >{{ getFnBCurrency.curr_code | uppercase }}&nbsp;{{
                        currFormat(getloyaltyAmount)
                      }}</strong
                    >
                    <div class="d-flex flex-wrap mt-2"></div>
                  </div>
                </div>
              </div>

               <div class="col-12" v-if="MeritCardAmount > 0 && GET_MERIT_GIFT_CARD_DETAILS.isApplied == 'Y'">
                <div class="d-flex border-bottom-lightgrey py-1">
                  <div class="col-5 pl-0">
                    <span class="text-lightgrey">Merit Gift Card</span>
                  </div>
                  <div class="col-7 px-0">
                    <strong>{{ GET_MERIT_GIFT_CARD_DETAILS.card_number }}</strong>
                  </div>
                </div>
                <div class="d-flex border-bottom-lightgrey py-1 text-danger">
                  <div class="col-5 pl-0">
                    <span class="text-lightgrey">Gift Card Amount</span>
                  </div>
                  <div class="col-7 px-0 d-flex align-item-center justify-content-between pr-3">
                    <strong
                      >-{{
                        MeritCardAmount > 0 && GET_MERIT_GIFT_CARD_DETAILS.isApplied == 'Y'
                          ? parseFloat(MeritCardAmount).toFixed(2)
                          : "0.00"
                      }}&nbsp;{{ currencyData.curr_code }}</strong
                    >
                    <img
                      @click="onRemoveMeritGiftCard()"
                      class="d-table position-relative"
                      src="@/assets/img/icons/delete.svg"
                      height="20"
                      width="20"
                    />
                  </div>
                </div>
              </div>

              <div id="myDiv"></div>
              <div
                v-if="offerApplied && Object.keys(offerApplied).length > 0"
                class="col-12"
              >
                <div class="d-flex flex-wrap border-bottom-lightgrey py-1">
                  <div class="col-5 pl-0">
                    <!-- class="text-lightgrey" -->
                    <strong class="font_size_12">Offer Applied</strong>
                  </div>
                  <div class="col-7 px-0">
                    <div class="d-flex justify-content-end">
                      <strong class="d-block text-danger"
                        ><span
                        class="font_size_12"
                          >-{{ getFnBCurrency.curr_code | uppercase }}&nbsp;{{
                            offerPrice
                          }}</span
                        ></strong
                      >
                    </div>
                  </div>
                  <div class="col-12 pt-1 px-0 d-flex">
                    <!-- <Tooltip
                      :title="`Offer Details here`"
                      :src="`question2.svg`"
                    /> -->
                    <strong class="fs-10 mr-2 pt-1 font_size_12"
                      >({{
                        offerApplied.offer_title ||
                          offerApplied.offer_code ||
                          offerApplied.voucher_title ||
                          offerApplied.voucher_code
                      }})</strong
                    >
                    <img
                      @click="onResetOffersAndPrice()"
                      class="d-table position-relative"
                      src="@/assets/img/icons/delete.svg"
                      height="20"
                      width="20"
                    />
                  </div>
                  <div class="col-4 pr-0">
                    <div class="d-flex w-100 justify-content-between"></div>
                  </div>
                </div>
              </div>
              <div
                v-if="
                  false && offerApplied && Object.keys(offerApplied).length > 0
                "
                class="col-12"
              >
                <div class="d-flex border-bottom-lightgrey py-2">
                  <div class="col-5 pl-0">
                    <span class="text-lightgrey font_size_12">Offer Applied</span>
                    <strong class="font_size_12">{{
                      offerApplied.offer_title || offerApplied.offer_code
                    }}</strong
                    >&nbsp;
                    <!-- <img
                      class="d-table position-relative"
                      src="@/assets/img/icons/question2.svg"
                      v-b-tooltip.hover
                      title="Offer Details here"
                      height="20"
                      width="20"
                    /> -->
                  </div>
                  <div class="col-7 px-0">
                    <div class="d-flex justify-content-between">
                      <strong class="d-block"
                        >{{ currFormat(offerPrice) }}&nbsp;{{
                          currencyData.curr_code
                        }}</strong
                      >
                      <img
                        @click="onResetOffersAndPrice()"
                        class="d-table position-relative"
                        src="@/assets/img/icons/delete.svg"
                        height="20"
                        width="20"
                      />
                    </div>
                  </div>
                  <div class="col-7 px-0">
                    <strong class="d-block text-right">
                      <!-- {{ offerApplied.oc_discount_value }} {{currencyData.curr_code}} -->
                      {{ getFnBCurrency.curr_code | uppercase }}&nbsp;-{{
                        currFormat(offerPrice)
                      }}
                    </strong>
                    <div class="d-flex flex-wrap mt-2"></div>
                  </div>
                </div>
              </div>
              <div v-if="isCashCardTransaction" class="col-12">
                <div class="d-flex border-bottom-lightgrey py-2">
                  <div class="col-5 pl-0">
                    <span class="text-lightgrey font_size_12">Cash Card</span>
                  </div>
                  <div class="col-7 px-0">
                    <div class="d-flex justify-content-between">
                      <strong class="d-block font_size_12">{{
                        isCashCardDetail.cash_card_number
                      }}</strong>
                    </div>
                  </div>
                </div>
                <div class="d-flex border-bottom-lightgrey py-2">
                  <div class="col-5 pl-0">
                    <span class="text-lightgrey font_size_12">Cash Card Amount</span>
                  </div>
                  <div class="col-7 px-0">
                    <div class="d-flex justify-content-between text-danger">
                      <strong
                      class="font_size_12"
                        >-{{
                          isCashCardDetail && isCashCardDetail.cardAmount
                            ? parseFloat(isCashCardDetail.cardAmount).toFixed(2)
                            : "0.00"
                        }}&nbsp;{{
                          getFnBCurrency.curr_code | uppercase
                        }}</strong
                      >
                      <img
                        @click="onRemoveCashCard()"
                        class="d-table position-relative"
                        src="@/assets/img/icons/delete.svg"
                        height="20"
                        width="20"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <footer class="summary-footer">
              <!-- <div class="col-12 py-1">
                <div class="row">
                  <div class="col-4">
                    <span class="text-black">Sub Total</span>
                  </div>
                  <div class="col-8 text-right">
                    <strong>{{ getFnBCurrency.curr_code | uppercase }} &nbsp;{{ selectedFnBItemsTotalPrice }}</strong>
                  </div>
                </div>
              </div>-->
              <!-- <div class="col-12 py-1">
                <div v-if="AdditionalTaxList.length === 0" class="row">
                  <div class="col-4">
                    <span class="text-black">Tax</span>
                  </div>
                  <div class="col-8 text-right">
                    <strong>{{ getFnBCurrency.curr_code | uppercase }}&nbsp;0</strong>
                  </div>
                </div>

                <div
                  v-if="AdditionalTaxList.length > 0"
                  v-for="(AdditionalTax,AdditionalTaxIndex) in AdditionalTaxList"
                  :key="AdditionalTaxIndex"
                  class="row"
                >
                  <div class="col-4">
                    <span class="text-black">{{ AdditionalTax.ct_name | uppercase}}</span>
                  </div>
                  <div class="col-8 text-right">
                    <strong>{{ getFnBCurrency.curr_code | uppercase }}&nbsp;{{ AdditionalTax.totalTax }}</strong>
                  </div>
                </div>
              </div>-->
              <div class="col-12 py-2" style="font-size: 16px">
                <div class="row">
                  <div class="col-5">
                    <div class="mb-0 font-weight-bold font_size_12">Grand Total</div>
                  </div>
                  <div class="col-7 text-right">
                    <div class="mb-0 font-weight-bold font_size_12">
                      {{ getFnBCurrency.curr_code | uppercase }} &nbsp;{{
                        parseFloat(
                          selectedFnBItemsTotalPrice +
                            TotalAdditionalTaxes +
                            selectedAddonsTotalPrice +
                            customizationTotalPrice +
                            BoxOfficetotalAmount -
                            offerPrice -
                            getloyaltyAmount -
                            paid_amount - parseFloat(MeritCardAmount || 0)
                        ).toFixed(2)
                      }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 py-1 px-1 border-top pt-2" v-if="EmpireClient">
                <div class="dropdown-curve-container">
                      <label :class="selectedStation_temp.station_id ? 'shift-up' : ''">
                        Fnb Station
                      </label>

                      <multiselect
                        v-model="selectedStation_temp"
                        @select="onSelectFnbStation($event, 'select')"
                        @remove="onSelectFnbStation($event, 'remove')"
                        placeholder=""
                        :options="stationsArray"
                        label="station_name"
                        track-by="station_id"
                        :multiple="false"
                        name="station_name"
                        id="station_name"
                        :showLabels="false"
                      >
                      </multiselect>
                    </div>
              </div>
            </footer>
          </div>
        </div>
      </div>
    </section>

    <!-- alternate items pop up -->
    <b-modal
      size="lg"
      hide-footer
      id="alternate-itmes-modal"
      title="Please select Alternate item"
    >
      <div class="row fnb-item-list" v-if="smCardView">
        <div
          class="py-3 col-4 position-parent"
          v-for="(food, key) in getAlternateItems"
          :key="key"
        >
          <div
            class="newCard row"
            @click="
              onAddFnBList({ ...food, itemIndex: key });
              onAddFnbItemCallback();
            "
            :style="
              !!food.fc_bgColor
                ? `background-color: ${food.fc_bgColor}`
                : 'background-color: var(--lightblue)'
            "
          >
            <div class="col-5 d-flex align-items-center m-0 pl-1 p-0">
              <div
                class="food-img img-hover br-10"
                style="cursor: pointer; border-radius: 10px"
              >
                <img
                  v-lazy="_GetImagePath(food.item_image_url)"
                  height="80"
                  width="90"
                />
              </div>
            </div>
            <div class="col-7 ">
              <div
                class="font-weight-bold"
                :title="food.item_name"
                :style="
                  !!food.fc_fontColor
                    ? `color: ${food.fc_fontColor}`
                    : 'color: var(--text)'
                "
              >
                {{ food.item_name || food.recipe_name }}
                <FoodMark
                  :isVeg="food.item_is_veg == 'Y' ? true : false"
                  :isEgg="food.includes_egg == 'Y' ? true : false"
                />
              </div>
              <div class="product-action position-child">
                <div class="" :style="'zoom: 0.8'">
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <span
                      v-if="
                        food.has_alternate_items &&
                          food.has_alternate_items == 'Y'
                      "
                      class="s_price_text"
                      :style="
                        !!food.fc_fontColor
                          ? `color: ${food.fc_fontColor}`
                          : 'color: var(--text)'
                      "
                    >
                      Starts From</span
                    >
                    <strong
                      :style="
                        !!food.fc_fontColor
                          ? `color: ${food.fc_fontColor}`
                          : 'color: var(--text)'
                      "
                      class="fs-16"
                      >{{ food.fp_total_amount }}&nbsp;{{
                        getFnBCurrency.curr_code | uppercase
                      }}</strong
                    >
                    <span
                      :id="'tooltip-fnb-add-button-disable-' + (key + 1)"
                      v-if="false"
                    >
                      <button class="btn-pos-add combo-btn-style">
                        +
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- alternate items pop up ends-->
    <b-modal
      size="lg"
      hide-footer
      ref="applicable-offer-modal"
      id="pos-applicable-offers"
      title="Select applicable offers"
    >
      <div>
        <b-tabs content-class="mt-3">
          <b-tab
            title="Offers &amp; Promotions"
            v-if="getOffersCollection.length > 0"
          >
            <div class="applicable-offer-wrapper">
              <ul class="pos-applicable-offers-list">
                <li
                  class
                  v-for="(OffersItem, OffersIndex) in getOffersCollection"
                  :key="OffersIndex"
                >
                  <div
                    name="applicableOffers"
                    v-model="ApplicableOfferSelected"
                    class="j-radio"
                  >
                    <div v-if="String(OffersItem.offer_type_id) === '1'">
                      <strong>{{
                        OffersItem.offer_title || OffersItem.offer_code
                      }}</strong>
                      Buy {{ OffersItem.oc_buy_no_of_ticket }} Tickets Get
                      {{ OffersItem.oc_get_free_ticket }} Tickets Free
                    </div>
                    <div v-else-if="String(OffersItem.offer_type_id) === '2'">
                      <strong>{{
                        OffersItem.offer_title || OffersItem.offer_code
                      }}</strong>
                      Buy {{ OffersItem.oc_buy_no_of_ticket }} Tickets &amp; Get
                      Discount of {{ OffersItem.oc_discount_value }}
                      {{
                        OffersItem.oc_discount_value_is_percentage === "Y"
                          ? "%"
                          : currencyData["curr_code"]
                      }}
                    </div>
                    <div v-else-if="String(OffersItem.offer_type_id) === '3'">
                      <strong>{{
                        OffersItem.offer_title || OffersItem.offer_code
                      }}</strong>
                      Combo Offers
                    </div>
                    <div v-else-if="String(OffersItem.offer_type_id) === '4'">
                      <strong>{{
                        OffersItem.offer_title || OffersItem.offer_code
                      }}</strong>
                      {{ OffersItem.buc_category_name }} Offers
                    </div>
                    <div v-else-if="String(OffersItem.offer_type_id) === '5'">
                      <strong>{{
                        OffersItem.offer_title || OffersItem.offer_code
                      }}</strong>
                      Bank Offers
                    </div>
                    <div v-else-if="String(OffersItem.offer_type_id) === '6'">
                      <strong>{{
                        OffersItem.offer_title || OffersItem.offer_code
                      }}</strong>
                      Promo code Offers
                    </div>
                    <div v-else-if="String(OffersItem.offer_type_id) === '7'">
                      <strong>{{
                        OffersItem.offer_title || OffersItem.offer_code
                      }}</strong>
                      <br />
                      Buy {{ OffersItem.oc_buy_no_of_ticket }}
                      {{
                        OffersItem.offer_redeem_at_concession == "Y"
                          ? "Tickets/Items"
                          : "Tickets"
                      }}
                      &amp; Get Flat {{ OffersItem.oc_discount_value }}
                      {{
                        OffersItem.oc_discount_value_is_percentage === "Y"
                          ? "%"
                          : currencyData["curr_code"]
                      }}
                      OFF.&nbsp;Only for Loyality Members
                    </div>
                    <div v-else-if="String(OffersItem.offer_type_id) === '8'">
                      <strong>{{
                        OffersItem.offer_title || OffersItem.offer_code
                      }}</strong>
                      Get Flat {{ OffersItem.oc_discount_value }}
                      {{
                        OffersItem.oc_discount_value_is_percentage === "Y"
                          ? "%"
                          : currencyData["curr_code"]
                      }}
                      OFF
                    </div>

                    <div v-else-if="OffersItem.offer_type_id == '9'">
                      <strong>{{
                        OffersItem.offer_title || OffersItem.offer_code
                      }}</strong>
                       {{getOfferDescription(OffersItem)}}
                    </div>

                    <div v-else-if="OffersItem.offer_type_id == '10'">
                      <strong>{{
                        OffersItem.offer_title || OffersItem.offer_code
                      }}</strong>
                      {{getOfferDescription(OffersItem)}}
                    </div>
                    <div v-else>
                      <strong>{{
                        OffersItem.offer_title || OffersItem.offer_code
                      }}</strong>
                      Not Available
                    </div>
                  </div>

                  <button
                    @click="
                      onClickApplyOffer({
                        event: $event,
                        offer: OffersItem,
                        offerFor: 'BoxOfficeFnbOffers'
                      })
                    "
                    class="btn-blue"
                  >
                    Apply
                  </button>
                  <button
                    v-b-toggle="'offer-details-' + OffersItem.os_id"
                    class="btn-transparent"
                  >
                    <small>Show Details</small>
                  </button>

                  <b-collapse :id="'offer-details-' + OffersItem.os_id">
                    <ul
                      v-if="String(OffersItem.offer_type_id) === '1'"
                      class="small pt-3"
                    >
                      <li class="py-1">
                        Minimun Ticket Price:
                        {{ OffersItem.oc_min_ticket_price }}
                      </li>
                      <li class="py-1">
                        Maximum Free Tickets Per Transactions:
                        {{ OffersItem.oc_max_no_of_ticket_per_transaction }}
                      </li>
                    </ul>
                    <ul
                      v-else-if="
                        String(OffersItem.offer_type_id) === '2' ||
                          String(OffersItem.offer_type_id) === '8'
                      "
                      class="small pt-3"
                    >
                      <li class="py-1">
                        Maximum discount per transaction:
                        {{ OffersItem.oc_max_discount_amount }}
                      </li>
                      <!-- <li class="py-1">Maximum Free Tickets Per Transactions: {{ OffersItem.oc_max_no_of_ticket_per_transaction }}</li> -->
                    </ul>
                    <ul
                      v-else-if="String(OffersItem.offer_type_id) === '3'"
                      class="small pt-3"
                    >
                      <li class="py-1">
                        Offer Combine With:
                        {{
                          OffersItem.oc_is_combo_with_fnb === "Y"
                            ? "F&B"
                            : "BoxOffice"
                        }}
                      </li>
                      <li
                        class="py-1"
                        v-if="OffersItem.oc_is_combo_with_fnb === 'Y'"
                      >
                        Buy {{ OffersItem.oc_buy_item_count }}
                        {{ OffersItem.buy_item_name }} F&amp;B Item &amp; Get
                        {{ OffersItem.oc_get_item_count }}
                        {{ OffersItem.get_item_name }} F&amp;B Item
                        <span v-if="OffersItem.oc_is_combo_free === 'Y'">{{
                          "Is Free"
                        }}</span>
                        <span v-if="OffersItem.oc_is_combo_free === 'N'"
                          >{{ OffersItem.oc_discount_value }}
                          {{
                            OffersItem.oc_discount_value_is_percentage === "Y"
                              ? "% OFF"
                              : `${currencyData["curr_code"]} OFF`
                          }}</span
                        >
                      </li>
                      <li
                        class="py-1"
                        v-if="OffersItem.oc_is_combo_with_fnb === 'N'"
                      >
                        Buy Tickets {{ OffersItem.oc_buy_no_of_ticket }} &amp;
                        Get F&amp;B Item {{ OffersItem.get_item_name }}
                        <span v-if="OffersItem.oc_is_combo_free === 'Y'">{{
                          "Is Free"
                        }}</span>
                        <span v-if="OffersItem.oc_is_combo_free === 'N'"
                          >{{ OffersItem.oc_discount_value }}
                          {{
                            OffersItem.oc_discount_value_is_percentage === "Y"
                              ? "% OFF"
                              : `${currencyData["curr_code"]} OFF`
                          }}</span
                        >
                      </li>
                    </ul>
                    <ul
                      v-else-if="String(OffersItem.offer_type_id) === '4'"
                      class="small pt-3"
                    >
                      <li class="py-1">
                        Minimun Ticket Price:
                        {{ OffersItem.cco_min_ticket_amount }}
                      </li>
                      <li class="py-1">
                        Maximum discount per transaction:
                        {{ OffersItem.cco_max_discount_amount }}
                      </li>
                      <li class="py-1">
                        Offer Price: {{ OffersItem.cco_offer_value }}
                        {{
                          OffersItem.cco_offer_value_is_percentage === "Y"
                            ? "%"
                            : currencyData["curr_code"]
                        }}
                      </li>
                      <li class="py-1">
                        Special Instruction:
                        <br />
                        <span v-html="OffersItem.cco_instruction"></span>
                      </li>
                    </ul>
                    <ul
                      v-else-if="String(OffersItem.offer_type_id) === '5'"
                      class="small pt-3"
                    >
                      <li class="py-1">
                        Bank Name: {{ OffersItem.bank_name }}
                      </li>
                      <li class="py-1">
                        Bank Card: {{ OffersItem.card_type }}
                      </li>
                      <li class="py-1" v-if="OffersItem.bo_weekly_redemption">
                        {{ "Weekly" }} Redemption:
                        {{ OffersItem.bo_weekly_redemption }}
                      </li>
                      <li class="py-1" v-if="OffersItem.bo_monthly_redemption">
                        {{ "Monthly" }} Redemption:
                        {{ OffersItem.bo_monthly_redemption }}
                      </li>
                      <li class="py-1" v-if="OffersItem.bo_yearly_redemption">
                        {{ "Yearly" }} Redemption:
                        {{ OffersItem.bo_yearly_redemption }}
                      </li>
                      <li class="py-1">
                        Offer Price: {{ OffersItem.bo_offer_value }}
                        {{
                          OffersItem.bo_offer_value_is_percentage === "Y"
                            ? "%"
                            : currencyData["curr_code"]
                        }}
                      </li>
                      <li class="py-1">
                        Special Instruction:
                        <br />
                        <span v-html="OffersItem.bo_instruction"></span>
                      </li>
                    </ul>
                    <ul
                      v-else-if="String(OffersItem.offer_type_id) === '6'"
                      class="small pt-3"
                    >
                      <li class="py-1">
                        Promo Code: {{ OffersItem.promo_code }} applicable for
                        {{
                          OffersItem.pcs_no_of_transactions
                            ? OffersItem.pcs_no_of_transactions
                            : "N/A"
                        }}
                        Transactions
                      </li>
                      <input
                        placeholder="."
                        type="text"
                        :value="promoCode"
                        @input="
                          onEnterPromoCodes({
                            event: $event,
                            name: 'enterPromoCode'
                          })
                        "
                        name="promocode"
                        id="promocode"
                      />
                      <li class="py-1">
                        Categories: {{ OffersItem.booking_user_category_id }}
                      </li>
                      <li class="py-1">
                        Minimun Ticket Price:
                        {{ OffersItem.pcs_min_ticket_amount }}
                      </li>
                      <li class="py-1">
                        Maximum discount per transaction:
                        {{ OffersItem.pcs_max_discount_amount }}
                      </li>
                      <li class="py-1">
                        Offer Price: {{ OffersItem.pcs_offer_value }}
                        {{
                          OffersItem.pcs_offer_value_is_percentage === "Y"
                            ? "%"
                            : currencyData["curr_code"]
                        }}
                      </li>
                      <li class="py-1">
                        Special Instruction:
                        <br />
                        <span v-html="OffersItem.pcs_instruction"></span>
                      </li>
                    </ul>
                    <ul
                      v-else-if="[9,10].includes(OffersItem.offer_type_id)"
                      class="small pt-3"
                    >
                      <li class="py-1">
                        {{getOfferDescription(OffersItem, true)}}
                      </li>
                      <li class="py-1" v-if="OffersItem.pcs_instruction">
                        Special Instruction:
                        <br />
                        <span v-html="OffersItem.pcs_instruction"></span>
                      </li>
                    </ul>
                    <ul v-else class="small pt-3">
                      <li class="py-1"></li>
                    </ul>
                  </b-collapse>
                </li>
              </ul>
            </div>
          </b-tab>
          <b-tab title="Vouchers" lazy>
            <!-- <div class="applicable-offer-wrapper">Sorry! There is no records found</div> -->
            <div class="applicable-offer-wrapper">
              <ul class="pos-applicable-offers-list">
                <li
                  class
                  v-for="(OffersVoucherItem,
                  OffersVoucherIndex) in getOffersVoucherCollection"
                  :key="OffersVoucherIndex"
                  v-if="OffersVoucherItem.is_open_voucher == 'N'"
                >
                  <div
                    name="applicableOffers"
                    v-model="ApplicableOfferSelected"
                    class="j-radio"
                  >
                    <div>
                      <strong
                        >{{
                          OffersVoucherItem.is_code_required == "N"
                            ? OffersVoucherItem.voucher_code + " -"
                            : ""
                        }}
                        {{ OffersVoucherItem.voucher_title }}</strong
                      >
                      <!-- VOUCHER CODE: {{ OffersVoucherItem.voucher_code }} -->
                    </div>
                  </div>

                  <!-- @click="onApplyOffer(OffersItem)" -->
                  <button
                    @click="checkVoucherDetails(OffersVoucherItem)"
                    class="btn-blue"
                  >
                    Apply
                  </button>
                  <button
                    v-b-toggle="
                      'offer-voucher-details-' + OffersVoucherItem.voucher_id
                    "
                    class="btn-transparent"
                  >
                    <small>Show Details</small>
                  </button>

                  <b-collapse
                    :id="
                      'offer-voucher-details-' + OffersVoucherItem.voucher_id
                    "
                  >
                    <ul class="small pt-3">
                      <li class="py-1">
                        Voucher value: {{ OffersVoucherItem.voucher_amount
                        }}{{
                          OffersVoucherItem.voucher_is_percentage === "Y"
                            ? "%"
                            : currencyData["curr_code"]
                        }}
                      </li>
                      <li class="py-1">
                        Min Bill/ticket amount for redemption:
                        {{ OffersVoucherItem.voucher_min_redemption_amount }}
                      </li>
                      <li class="py-1">
                        Max Bill/ticket amount for redemption:
                        {{ OffersVoucherItem.voucher_max_redemption_amount }}
                      </li>
                      <li class="py-1">
                        Terms &amp; Conditions:
                        <br />
                        <span v-html="OffersVoucherItem.voucher_terms"></span>
                      </li>
                      <li v-if="OffersVoucherItem.vp_partner_name" class="py-1">
                        Partner Name:
                        <br />
                        <span v-html="OffersVoucherItem.vp_partner_name"></span>
                      </li>
                      <!--  -->
                    </ul>
                    <!-- <ul v-else class="small pt-3">
                      <li class="py-1"></li>
                    </ul>-->
                  </b-collapse>
                </li>
              </ul>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </b-modal>
    <BoxOfficeFnbFooter :onClickHandler="onClickCall" />
    <!-- <PosFnb /> -->

    <PosFnbPickup
      v-if="childComponents.PosFnbPickup"
      :onPrintCall="GoToRoute"
      :printText="printText"
      :onClickHandler="onClickCall"
    />

<PosUserFnBTransaction
v-if="childComponents.posUserFnbTransaction"
:onClickHandler="onClickCall"
/>
    <PosMultiFnB
      v-if="childComponents.PosMultiFnB"
      :onClickHandler="onClickCall"
    />

    <!-- FILTER -->
    <b-modal
      hide-footer
      ref="reffilterFnbItems"
      id="filterFnbItems"
      title="Filter "
    >
      <div class="col-12 text-center border-bottom">
        <h5 class="py-2">Filter Items</h5>
      </div>
      <div class="my-2" style="max-height: 50vh; overflow: auto">
        <b-form-group class="mt-3">
          <b-form-checkbox-group
            text-field="fc_category"
            value-field="fc_id"
            size="lg"
            :options="fnbSubSubCategories"
            plain
            stacked
            @input="setOnFnBPayloads({ event: $event, name: 'subCategory' })"
          ></b-form-checkbox-group>
        </b-form-group>
      </div>
      <div class="col-12 text-center border-top pt-3">
        <button
          @click="$refs['reffilterFnbItems'].hide()"
          class="btn-white-lg mr-1"
        >
          Cancel
        </button>
        <button @click="fetchFnBItems" class="btn-blue-lg ml-1">Filter</button>
      </div>
    </b-modal>
    <b-modal
      size="lg"
      hide-footer
      id="customization-modal"
      title="Add customization to your item"
    >
      <div>
        <div class="row text-uppercase font-weight-bold pb-2 border-bottom">
          <div :class="['align-self-center col-5']">
            <span class="px-3">Item</span>
          </div>
          <div class="col-2 align-self-center text-center">
            <!-- <span>UOM</span> -->
          </div>
          <div class="col-2 align-self-center text-center">
            <!-- <span>PRICE</span> -->
          </div>
          <div class="col-3 text-right">
            <span class="px-3">Action</span>
          </div>
        </div>
        <div class="row mx-0">
          <div
            class="col-12 py-3 border-bottom"
            :key="customizationIndex"
            v-for="(customization, customizationIndex) in customizationsList"
          >
            <div class="row">
              <div
                :class="[
                  'align-self-center',
                  customization.item_name && customization.item_name == 'Y'
                    ? 'col-5'
                    : 'col-5'
                ]"
              >
                <span class="font-weight-semi-bold">{{
                  customization.item_name
                }}</span>
              </div>
              <div class="col-2 align-self-center text-center">
                <!-- {{ customization.customization_item_quantity }}&nbsp;{{
                      customization.uom_unit
                    }} -->
              </div>
              <!-- <div
                    class="col-2 align-self-center text-center"
                    v-if="
                      customization.is_extra_charges_applicable &&
                        customization.is_extra_charges_applicable == 'Y'
                    "
                  >
                    <span class="font-weight-semi-bold"
                      >{{ getFnBCurrency && getFnBCurrency.curr_code }}&nbsp;{{
                        customization.charges_value | RoundOff
                      }}</span
                    >
                  </div>
                  <div class="col-2 align-self-center text-center" v-else>
                    <span>-</span>
                  </div> -->
              <div class="col-2 align-self-center text-center"></div>
              <div class="col-3 text-right">
                <button
                  @click="onSelectCustomization(customization)"
                  class="btn-outline-blue mx-0"
                >
                  Add
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="verifyBOXFNBVoucher"
      ref="verifyBOXFNBVoucher"
      title="Verify Voucher"
      hide-footer
      show
      @hide="clearVoucherCode"
    >
      <div>
        <div class="row mb-3 mt-2">
          <!-- <h6 class="px-3">Voucher Code</h6> -->
          <div class="col-10 mb-4 d-flex input-material mx-auto">
            <input
              placeholder="Voucher Code"
              type="text"
              v-model="voucherCodeValue"
              v-on:keyup.enter="
                applyBoxOfficeFnbOffersHandler({
                  event: $event,
                  offer: OffersItem,
                  offerFor: 'BoxOfficeFnbVouchers',
                  checkSpecificTitle: 'Y',
                })
              "
              @input="
                onEnterVoucherCode({
                  event: $event,
                  name: 'enterVoucherCode'
                })
              "
              name="voucherCode"
              id="voucherCode"
              class="form-control"
              @click="onClickInputHandler('showVerifyVoucher')"
            />
            <label>{{ "Enter Voucher Code" }}</label>
            <VkeyboardFloat
              :ID="'voucherCode'"
              :onClickFun="
                () => {
                  Object.keys(keyboardsVisible).map(x => {
                    if (x == 'showVerifyVoucher') {
                      keyboardsVisible[x] = !keyboardsVisible[x];
                    } else {
                      keyboardsVisible[x] = false;
                    }
                  });
                }
              "
            />
            <Vkeyboard
              :inputName="'voucherCode'"
              :showOrHide="keyboardsVisible.showVerifyVoucher"
              :initialValue="voucherCodeValue"
              @onChangeEvent="() => {}"
              @onKeyEnter="
                applyBoxOfficeFnbOffersHandler({
                  event: $event,
                  offer: OffersItem,
                  offerFor: 'BoxOfficeFnbVouchers',
                  checkSpecificTitle: 'Y',
                })
              "
              @changeKeyboardInput="
                event => {
                  voucherCodeValue = event;
                  onEnterVoucherCode({
                    event: {
                      target: {
                        value: event
                      }
                    },
                    name: 'enterVoucherCode'
                  });
                }
              "
              @onClickClose="
                () => {
                  keyboardsVisible.showVerifyVoucher = false;
                }
              "
            />
          </div>
          <div class="col-10 mb-4 d-flex input-material mx-auto">
            <input
              placeholder="Comment"
              type="text"
              :value="getTransactionComment"
              @input="onInputComment($event)"
              name="voucherComment"
              id="voucherComment"
              class="form-control"
              @click="onClickInputHandler('showCommentKeyboard')"
            />
            <label>{{ "Enter Comment" }}</label>
            <VkeyboardFloat
              :ID="'voucherComment'"
              :onClickFun="
                () => {
                  Object.keys(keyboardsVisible).map(x => {
                    if (x == 'showCommentKeyboard') {
                      keyboardsVisible[x] = !keyboardsVisible[x];
                    } else {
                      keyboardsVisible[x] = false;
                    }
                  });
                }
              "
            />
            <Vkeyboard
              :inputName="'voucherComment'"
              :showOrHide="keyboardsVisible.showCommentKeyboard"
              :initialValue="getTransactionComment"
              @onChangeEvent="() => {}"
              @onKeyEnter="
                () => {
                  keyboardsVisible.showCommentKeyboard = false;
                }
              "
              @changeKeyboardInput="
                onInputComment({
                  target: {
                    value: $event
                  }
                })
              "
              @onClickClose="
                () => {
                  keyboardsVisible.showCommentKeyboard = false;
                }
              "
            />
          </div>
          <div class="col-12 py-2 text-center">
            <button
              @click="
                applyBoxOfficeFnbOffersHandler({
                  event: $event,
                  offer: OffersItem,
                  offerFor: 'BoxOfficeFnbVouchers',
                  checkSpecificTitle: 'Y',
                })
              "
              class="btn-blue ml-5"
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="extendSeatRelease"
      title="Seat Release"
      hide-footer
      hide-header
      no-close-on-backdrop
      @shown="onShowSeatReleasePopUp"
      @hide="onHideSeatReleasePopUp"
    >
      <div class="text-center pb-1">
        <div class="svg-container">
          <svg
            width="40pt"
            height="40pt"
            version="1.1"
            viewBox="0 0 1200 1200"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g fill="#ffd65b">
              <path
                d="m1110.4 938.2-426.89-693.25c-56.07-91.074-125.64-100.98-195.69-10.223-136.33 176.61-249.52 369.7-362.32 562.19-19.43 33.16-39.055 66.762-49.668 103.7-10.613 36.941-11.418 78.184 6.0195 112.43 27.441 53.895 90.504 63.438 150.75 62.586 867.37-10.098 822.88-6.6133 851.53-16.758 46.281-16.402 65.977-56.125 26.273-120.67zm-34.504 97.426c-24.562 8.6953 16.367 5.3359-843.58 15.348-44.805 0.73828-99.207-3.5469-120.01-40.004-19.488-34.129-0.64062-78.469 20.355-117.33h0.007813c167.91-310.92 303.09-483.67 368.43-586.42 21.879-34.418 44.508-69.992 70.031-96.879 7.2383-7.6328 15.734-12.711 26.199-11.637 22.645 2.3594 48.52 32.121 65.184 59.188l426.89 693.25c23.516 38.16 29.102 69.395-13.508 84.48z"
              />
              <path
                d="m780.21 125.03c-6.4219-2.2812-13.469 1.0742-15.75 7.4961l-30.621 86.078c-2.2812 6.4062 1.0664 13.453 7.4805 15.75 6.3789 2.25 13.449-1.0312 15.75-7.4961l30.621-86.078c2.2812-6.4062-1.0664-13.453-7.4805-15.75z"
              />
              <path
                d="m852.91 194.24c-20.004 26.922-43.891 50.582-70.996 70.328-5.5078 4.0117-6.7188 11.719-2.7031 17.227 4.0078 5.5312 11.742 6.6992 17.219 2.7148 29.121-21.223 54.781-46.633 76.277-75.562 4.0625-5.457 2.9219-13.18-2.543-17.242-5.4453-4.0781-13.168-2.9414-17.254 2.5352z"
              />
              <path
                d="m815.8 322.32c0.17578 6.6953 5.6602 12.008 12.32 12.008 9.3984-1.0586 32.441 0.10156 67.086-13.582 6.332-2.4883 9.4375-9.6484 6.9414-15.988-2.5117-6.3398-9.6797-9.457-15.996-6.9336-18.645 7.3516-38.27 11.332-58.336 11.848-6.8047 0.17578-12.184 5.8438-12.016 12.648z"
              />
              <path
                d="m609.96 389h-13.082c-17.531 0-31.742 14.211-31.742 31.742l0.003907 343.96c0 17.531 14.211 31.742 31.742 31.742 17.031 0 31.074-13.438 31.785-30.449 4.7812-114.63 8.1758-229.34 12.938-343.97 0.74609-18.02-13.609-33.023-31.645-33.023z"
              />
              <path
                d="m583.05 846.32-4.2969 1.4219c-19.625 7.7188-30.715 32.266-23.543 52.098 7.1758 19.828 31.406 31.598 51.426 24.973 20.02-6.625 32.453-30.523 26.383-50.719s-29.613-33.281-49.969-27.773z"
              />
            </g>
          </svg>
        </div>
        <p class="fs-16 mb-4">
          <span class="font-weight-bold">Alert!</span> <br />
          Your seats will be released in&nbsp;<span
            class="font-weight-bold text-danger"
            >{{ seatReleaseIn }}</span
          ><br />Do You Want to Extend Time ?
        </p>

        <button
          class="btn-outline-blue"
          @click.prevent.stop="$bvModal.hide('extendSeatRelease')"
        >
          Cancel
        </button>
        <span class="mx-1"></span>
        <button
          class="btn btn-blue px-4 fs-14"
          @click.prevent.stop="handleExtendSeatRelease"
        >
          Continue
        </button>
      </div>
    </b-modal>

    <!-- Combo Pack pop up -->
    <b-modal
      size="xl"
      hide-footer
      hide-header
      id="comboPackModal"
      ref="comboPackModal"
      title="Customise Your Combo"
    >
      <div class="combo-modal-wrapper">
        <div class="text-center font-weight-bold fs-20 my-2">
          <div class="mb-2" style="font-size: 22px">
            Customise Your Combo
          </div>
        </div>
        <div
          class="row mb-2"
          v-for="(category, categoryindex) in ComboPackArray"
          :key="categoryindex"
        >
          <div class="col-12 category-title">
            <div class="d-flex justify-content-between category-title-box">
              <div>
                {{ category.category_name }} &nbsp;&nbsp;&nbsp;
                <span class="combo-item-count">
                  {{
                    category.combo_items
                      .filter(x => x.quantity > 0)
                      .map(y => y.quantity + "x -" + y.item_name)
                      .join(", ")
                  }}
                </span>
              </div>
              <div class="quantityCount">
                Selected: {{ getComboItemSelectedByCategory(categoryindex) }} /
                {{ category.quantity }}
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row fnb-item-list" v-if="smCardView">
              <div
                class="py-3 col-4"
                v-for="(food, key) in category.combo_items"
                :key="key"
              >
                <div
                  class="newCard row"
                  :style="
                    !!food.fc_bgColor
                      ? `background-color: ${food.fc_bgColor}`
                      : 'background-color: var(--lightblue)'
                  "
                >
                  <!-- <span class="selectedComboItem-sm tick-green-item" v-if="food.quantity > 0"></span> -->
                  <div class="selectedComboItem-sm" v-if="food.quantity > 0">
                    <span class="tick-green-item"></span>
                  </div>
                  <div class="col-5 d-flex align-items-center m-0 pl-1 p-0">
                    <div
                      class="food-img img-hover br-10"
                      style="cursor:pointer; border-radius: 10px"
                    >
                      <img
                        v-lazy="_GetImagePath(food.item_image_url)"
                        height="80"
                        width="90"
                      />
                    </div>
                  </div>
                  <div class="col-7 position-parent mb-1">
                    <div class="font-weight-bold" style="font-size:13px">
                      {{ food.item_name }}
                      <FoodMark
                        :isVeg="food.item_is_veg == 'Y' ? true : false"
                        :isEgg="food.includes_egg == 'Y' ? true : false"
                      />
                    </div>
                    <div class="product-action position-child">
                      <div class="" :style="'zoom: 0.8'">
                        <div
                          class="d-flex align-items-center justify-content-between"
                        >
                          <button
                            class="btn-pos-subtract-white combo-btn-style"
                            @click.prevent.stop="
                              onChangeComboItems(
                                food,
                                key,
                                category,
                                categoryindex,
                                'minus'
                              )
                            "
                          >
                            &minus;
                          </button>
                          <strong class="fs-20" style="margin:0 10px">{{
                            food.quantity
                          }}</strong>
                          <button
                            class="btn-pos-add-white combo-btn-style"
                            @click.prevent.stop="
                              onChangeComboItems(
                                food,
                                key,
                                category,
                                categoryindex,
                                'add'
                              )
                            "
                          >
                            +
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row fnb-item-list" v-else>
              <div
                class="py-3"
                :style="'width: calc(100% / 5)'"
                v-for="(food, key) in category.combo_items"
                :key="key"
              >
                <div
                  class="combo-food-card mx-auto"
                  :class="food.quantity > 0 ? 'activeComboItems' : ''"
                >
                  <div class="food-img img-hover" style="cursor:pointer">
                    <img
                      v-lazy="_GetImagePath(food.item_image_url)"
                      class="img-fluid"
                    />
                  </div>
                  <div
                    class="combo-detail-card"
                    :style="
                      !!food.fc_bgColor
                        ? `background-color: ${food.fc_bgColor}`
                        : 'background-color: var(--lightblue)'
                    "
                  >
                    <div
                      class="text-uppercase font-weight-bold combo-item-name"
                      :style="
                        !!food.fc_fontColor
                          ? `color: ${food.fc_fontColor}`
                          : 'color: var(--text)'
                      "
                    >
                      {{ food.item_name }}
                    </div>
                    <div class="text-white" :style="'zoom: 0.8'">
                      <div
                        class="px-3 d-flex align-items-center justify-content-between"
                      >
                        <button
                          class="btn-pos-subtract combo-btn-style"
                          @click.prevent.stop="
                            onChangeComboItems(
                              food,
                              key,
                              category,
                              categoryindex,
                              'minus'
                            )
                          "
                        >
                          &minus;
                        </button>
                        <strong class="fs-20">{{ food.quantity }}</strong>
                        <button
                          class="btn-pos-add combo-btn-style"
                          @click.prevent.stop="
                            onChangeComboItems(
                              food,
                              key,
                              category,
                              categoryindex,
                              'add'
                            )
                          "
                        >
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="selectedComboItem" v-if="food.quantity > 0">
                  <span class="tick-green-item"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center mt-4">
            <button
              class="btn-blue"
              :disabled="false"
              :class="false ? 'disabled' : ''"
              @click="onSaveComboChanges"
            >
              {{ "Submit" }}
            </button>
            <button class="btn-blue" @click="$bvModal.hide('comboPackModal')">
              {{ "Cancel" }}
            </button>
          </div>
        </div>
      </div>
    </b-modal>
    <ManagerAuthLogin
      :moduleName="'posOfferAuth_bo_fnb'"
      :onCheckAuth="onCheckOfferAuth"
      :refId="'posOfferAuth_bo_fnb'"
    />
    <AddEmployeeDiscountDetails :moduleName="'bo_fnb'" :refId="'addEmployeeDetails_bofnb'" :onCheckEmployeeDetails="onCheckEmployeeDetails"/>
    <!-- Combo Pack pop up ends-->
  </div>
</template>

<script>
import posFnBHeader from "@/components/Partials/posFnBHeader";
import PosFnbFooter from "@/components/Partials/posFnbFooter";
import BoxOfficeFnbFooter from "@/components/Pages/BoxOfficeFnbContainer/boxOffiiceFnbFooter";
import PosUserFnBTransaction from "@/components/Pages/PosBookingContainer/posUserFnbTransaction";
import BoxOfficeFnbFinalTicket from "@/components/Pages/BoxOfficeFnbContainer/NewBoxOfficeFnbFinalTicket";
import PosFnbPopcorn from "@/components/Pages/PosFnbContainer/posFnbPopcorn";
import PosFnbCheckout from "@/components/Pages/PosFnbContainer/posFnbCheckout";
import PosFnBFinalTicket from "@/components/Pages/PosFnbContainer/posFnBFinalTicket";
import PosFnbPickup from "@/components/Pages/PosFnbContainer/posPickupFnB";
import PosMultiFnB from "@/components/Pages/PosFnbContainer/posMultiFnB";
import { mapState, mapGetters, mapActions } from "vuex";
import { EventBus } from "@/main";
import MasterService from "@/services/MasterService.js";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
import _ from "lodash";
import FoodMark from "@/components/UIElements/VegMark.vue";
import { CLIENT_NAME } from "@/helper/Role";
import ManagerAuthLogin from "@/components/Partials/AuthManagerLoginPopup";
import AddEmployeeDiscountDetails from "@/components/Partials/AddEmployeeDiscountDetails";


export default {
  components: {
    posFnBHeader,
    BoxOfficeFnbFooter,
    PosUserFnBTransaction,
    PosFnbFooter,
    PosFnbPopcorn,
    PosFnbCheckout,
    PosFnBFinalTicket,
    BoxOfficeFnbFinalTicket,
    PosFnbPickup,
    PosMultiFnB,
    VkeyboardFloat,
    Vkeyboard,
    FoodMark,
    ManagerAuthLogin,
    AddEmployeeDiscountDetails
  },
  data() {
    return {
      tempSelectedOffer: null,
      employeeDetailsAuth: false,
      windowHeight:window.innerHeight,
      windowWidth:window.innerWidth,
      smCardView: true,
      SelectedComboIndex: null,
      ComboPackArray: [],
      keyboardsVisible: {
        showFnbSearchKeyboard: false,
        showVerifyVoucher: false,
        showCommentKeyboard: false
      },
      showAddonBreakup: false,
      showSeatExtendPopUp: false,
      timePassed: 0,
      timeLeft: 0,
      timerInterval: null,
      seatReleaseIn: `00:00`,
      showSeatReleaseMsg: null,
      seatReleasePopUp: null,
      hideSeatExtendPopUp: null,
      OffersItem: "",
      voucherCodeValue: "",
      ApplicableOfferSelected: "",
      currencyData: [],
      // Saif

      // Saif
      totalAmount: 0,
      taxAmount: 0,
      fnbComponents: {
        popCorn: true
      },
      childComponents: {
        PosFnbPickup: false,
        PosMultiFnB: false,
        posUserFnbTransaction:false,
      }
    };
  },
  watch: {
    "$store.getters.SelectedFnbItemList": function(newVal, oldVal) {
      if (newVal && newVal.length === 0) {
        this.onResetOffersAndPrice();
      } else if (
        Object.keys(this.getSelectedOffer).filter(
          x =>
            this.getSelectedOffer[x] !== null &&
            this.getSelectedOffer[x] !== undefined
        ).length > 0 &&
        !this.removeOfferItemFlag
      ) {
        this.applyFnbOffersHandler({
          event: null,
          offer: this.getSelectedOffer,
          offerFor: this.getOfferFor
        });
      }
    },
    "$store.getters.booking_complete": function(newVal) {
      console.log("Booking Complete Box Office Fnb");
      if (newVal) {
        clearTimeout(this.seatReleasePopUp);
        clearTimeout(this.hideSeatExtendPopUp);
        clearTimeout(this.showSeatReleaseMsg);
      }
    }
  },
  computed: {
    GET_MERIT_GIFT_CARD_DETAILS() {
      return this.$store.getters.GET_MERIT_GIFT_CARD_DETAILS;
    },
    MeritCardAmount() {
      let amount = 0;
      let gc_details = this.$store.getters.GET_MERIT_GIFT_CARD_DETAILS;
      if(gc_details) {
        amount = +parseFloat(gc_details['amount']).toFixed(2)
      }
      // return amount
      return 0;
    },
    EmpireClient() {
      return CLIENT_NAME.EMPIRE == this.CLIENT_SETUP_NAME;
    },
    check_station() {
      return this.$store.getters.GET_SELECTED_STATION;
    },
    selectedStation_temp: {
      get() {
        return this.$store.getters.GET_SELECTED_STATION;
      },
      set(value) {
        let selectedStation = {
          station_id: null,
          station_name: null,
        }
        Object.keys(selectedStation).map((key) => {
          selectedStation[key] = value && value[key] ? value[key] : null
        })
        this.$store.commit('SET_SELECTED_STATION', {selectedStation : selectedStation})
      }
    },
    stationsArray() {
       return this.$store.getters.GET_FNB_STATIONS;
    },
    reservationId() {
      return this.$store.getters.reservationId;
    },
    POS_SEAT_EXTEND_TIMER() {
      return this.$store.getters.POS_SEAT_EXTEND_TIMER;
    },
    POS_SEAT_ALERT_TIME_IN_SEC() {
      return this.$store.getters.POS_SEAT_ALERT_TIME_IN_SEC;
    },
    CINE_SEAT_RELEASE_TIME_IN_MINS() {
      return this.$store.getters.CINE_SEAT_RELEASE_TIME_IN_MINS;
    },
    isCashCardTransaction() {
      return this.$store.getters.isCashCardTransaction;
    },
    CashCardAmount() {
      return this.$store.getters.isCashCardDetail.hasOwnProperty("cardAmount")
        ? this.$store.getters.isCashCardDetail.cardAmount
        : 0;
    },
    offerApplied() {
      return this.$store.getters.getSelectedOffer;
    },
    offerPrice() {
      return this.getOfferPrice ? parseFloat(this.getOfferPrice).toFixed(2) : 0;
    },
    currencyCode() {
      return this.currencyData["curr_code"]
        ? this.currencyData["curr_code"]
        : "";
    },
    showDetails() {
      return this.$store.getters.SHOW_DETAILS;
    },
    selectedSeats() {
      return this.$store.getters.SELECTED_SEATS;
    },
    netTotal() {
      return this.$store.getters.NET_AMOUNT;
    },
    BoxOfficetotalAmount() {
      return this.$store.getters.TOTAL_AMOUNT;
    },
    additionalCharges() {
      return this.$store.getters.ADDITIONAL_CHARGES;
    },
    // ...mapState(["fnbSearch"]),
    ...mapGetters([
      "GET_FNB_STATIONS",
      "fnbItems",
      "paid_amount",
      "isCashCardDetail",
      "isFnbDataLoading",
      "SelectedFnbItemList",
      "fnbSubSubCategories",
      "getFnBCurrency",
      "AdditionalTaxList",
      "showViewOffers",
      "getOffersCollection",
      // "OffersFnbItems",
      "getSelectedOffer",
      "getOfferFor",
      "getOfferPrice",
      "getOffersVoucherCollection",
      //
      "getloyaltyAmount",
      "isLoyaltyApplied",
      "LoyaltyProgram",
      //addons
      "selectedAddons",
      "selectedAddonsTotalPrice",
      "totalAddonsAdditionalTaxes",
      "addonsAdditionalCharges",
      //
      "getAlternateItems",
      "PosMultiFnbFlag",
      "getCustomerDetails",
      "customizationsList",
      "selectedChargeableCustomizations",
      "customizationTotalPrice",
      "customizationAdditionalTaxes",
      "customizationTaxesPrice",
      "getVoucherCode",
      "getTransactionComment",
      "RateCardAddonsChargesList",
      "RateCardAddonsChargesFinalAmount",
      "RateCardAddonsOnTicketChargesFinalAmount",
      "RateCardAddonsOnTicketChargesList",
      "RateCardAddonsOnTicketChargeTypes",
    ]),
    ...mapState({
      showFnBOrderDetails: state => state.FnBStore.showFnBOrderDetails,
      FnBItemsModule: state => state.FnBStore.FnBItemsModule,
      fnbSearch: state => state.FnBStore.fnbPayload.search,
      isVeg: state => state.FnBStore.fnbPayload.isVeg,
      isEgg: state => state.FnBStore.fnbPayload.isEgg,
      selectedFnBItemsTotalPrice: state =>
        state.FnBStore.selectedFnBItemsTotalPrice,
      TotalAdditionalTaxes: state => state.FnBStore.totalAdditionalTaxes,
      cashInputValue: state => state.FnBStore.cashInputValue,
      printText: state => state.FnBStore.printText,
      promoCode: state => state.PosOffersStore.promocode
    })
  },
  beforeMount() {
    this.fetchFnbStations();
    // this.setFnbPosFooterMenus();
  },
  destroyed: function() {
    console.log("called on destroyed");
    this.showSeatExtendPopUp = false;
    clearTimeout(this.seatReleasePopUp);
    clearTimeout(this.hideSeatExtendPopUp);
    clearTimeout(this.showSeatReleaseMsg);
    this.$bvModal.hide("extendSeatRelease");
    this.onTimesUp();
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
    let cinemaId = null;
    let userDetails = null;
    if (this.secureStore.get("USINFO")) {
      cinemaId =
        this.secureStore.get("USINFO") &&
        this.secureStore.get("USINFO")["cinema_id"]
          ? this.secureStore.get("USINFO").cinema_id
          : null;
      userDetails =
        this.secureStore.get("USINFO").first_name +
        " " +
        this.secureStore.get("USINFO").last_name;
    }
    let stockDeduction = this.secureStore.get("BRGLOPSTDE")
      ? this.secureStore.get("BRGLOPSTDE")
      : null;
    let stockDeductionConcession = this.secureStore.get("BRGLOPSTDECO")
      ? this.secureStore.get("BRGLOPSTDECO")
      : null;
    this.SetCinemaId({
      cinemaId,
      userDetails,
      stockDeduction,
      stockDeductionConcession
    });
    this.fetchCalculatorCash();
    this.fetchFnBItems();
    this.fetchFnBCategories({cinema_id: cinemaId});
    this.fetchCurrencyCode({ curr_id: this.secureStore.get("BRGLOPCUR") });
    this.fetchCinemaDetails(cinemaId);
    EventBus.$on("startSeatRealeaseTimeBoxOffice", data => {
      console.log("Emitted On startSeatRealeaseTime BOXOFFICE");
      this.showSeatExtendPopUp = true;
      if (this.POS_SEAT_EXTEND_TIMER && this.POS_SEAT_EXTEND_TIMER > 0) {
        this.seatReleasePopUp = setTimeout(() => {
          this.timeLeftTimer();
          if (this.showSeatExtendPopUp) {
            console.log("line 1778 TEST extendSeatRelease called");
            this.$bvModal.show("extendSeatRelease");
          }
        }, this.POS_SEAT_EXTEND_TIMER);
      }
      if (
        this.CINE_SEAT_RELEASE_TIME_IN_MINS &&
        this.CINE_SEAT_RELEASE_TIME_IN_MINS > 0
      ) {
        this.showSeatReleaseMsg = setTimeout(() => {
          console.log("Seat relase message timeout");
          this.seatTimeout();
        }, this.CINE_SEAT_RELEASE_TIME_IN_MINS * 60 * 1000);
      }
    });
    EventBus.$on("clearSeatTimerPopUp", data => {
      console.log("Clearing Time Outs For Seat Release Pop Up");
      this.showSeatExtendPopUp = false;
      clearTimeout(this.seatReleasePopUp);
      clearTimeout(this.hideSeatExtendPopUp);
      clearTimeout(this.showSeatReleaseMsg);
      this.onTimesUp();
      this.$bvModal.hide("extendSeatRelease");
    });

    EventBus.$on("openComboModal", payload => {
      let orderIndex = this.SelectedFnbItemList.findIndex(
        x => x.item_id == payload.item_id
      );
      if (orderIndex > -1) {
        let order = this.SelectedFnbItemList[orderIndex];
        this.onCustomizeCombo(order, orderIndex);
      }
    });
  },

  beforeDestroy() { 
    window.removeEventListener('resize', this.onResize); 
  },

  methods: {
     onCheckOfferAuth(response) {
        const { valid, name, user_id } = response;
        if (valid) {
          if (name == "posOfferAuth_bo_fnb") {
            this.$bvModal.hide("posOfferAuth_bo_fnb");
            this.$bvModal.show('addEmployeeDetails_bofnb')
          }
        }
      },
     onCheckEmployeeDetails(response) {
        const { valid, name } = response;
        if (valid) {
          if (name == "bo_fnb") {
            this.employeeDetailsAuth = true;
            this.$bvModal.hide("addEmployeeDetails_bofnb");
            this.$bvModal.hide('posOfferAuth_bo_fnb')
            this.onClickApplyOffer(this.tempSelectedOffer);
          }
        }
      },
    onClickApplyOffer(offerPayload) {
      const {event, offer, offerFor} = offerPayload;
      if(offer.hasOwnProperty('is_employee_offer') && offer.is_employee_offer == 'Y') {
        this.tempSelectedOffer = _.cloneDeep(offerPayload);
        if(!this.employeeDetailsAuth) {
          this.onResetEmployeeDetails();
          this.$bvModal.hide('pos-applicable-offers')
          this.$bvModal.show('posOfferAuth_bo_fnb')
        } else {
          this.applyBoxOfficeFnbOffersHandler({
            event: event,
            offer: offer,
            offerFor: offerFor
          })
          this.tempSelectedOffer = null;
          this.employeeDetailsAuth = false;
        }
      } else {
        this.applyBoxOfficeFnbOffersHandler({
            event: event,
            offer: offer,
            offerFor: offerFor
          })
      }
    },
    onRemoveMeritGiftCard() {
      this.resetMeritCardDetails();
    },
     onSelectFnbStation(station, type) {
      console.log('check_station', this.check_station);
      let selectedStation = {
        station_id: null,
        station_name: null,
      }
      if(type == 'select') {
        Object.keys(selectedStation).map((key) => {
          selectedStation[key] = station[key] || null
        })
      }
      this.$store.commit('SET_SELECTED_STATION', {selectedStation : selectedStation})
    },
    onResize() {
      this.windowHeight = window.innerHeight
      this.windowWidth = window.innerWidth
    },
    rateCardAddonsChargeTypeToAdd(ct_id) {
      let result = 0
      if (!ct_id) return result

      result = this.RateCardAddonsOnTicketChargeTypes
      .filter(c => (c.ct_id == ct_id))
      .map(c => (c.final_value || 0))
      .reduce((prev, curr) => prev + curr, 0)
      return result || 0
    },
    rateCardAddonsNetAdd() {
      let result = 0
      result =  this.RateCardAddonsOnTicketChargeTypes
      .map(c => (c.net_value || 0))
      .reduce((prev, curr) => prev + curr, 0)

      return result
    },
      getOfferDescription(offer, moreInfo = false) {
      let text = ``;
      if(offer.offer_type_id == 9) {
        if(moreInfo) {
          let offerCondition = offer.oc_max_no_of_ticket_per_transaction || '';
          if(offerCondition) {
          text += `Max Apply limit ${offerCondition}`
          }
        } else {
          text += `Buy ${offer.oc_buy_no_of_ticket} Ticket @ ${offer.oc_discount_value} Each.`
          let FNB_Criteria = []
          if(offer.oc_is_combo_with_fnb  == 'Y' && offer.fnb_group_data) {
            try {
              FNB_Criteria = offer.fnb_group_data ? JSON.parse(offer.fnb_group_data) : []
            } catch (err) {
              console.log('Error', err);
              FNB_Criteria = offer.fnb_group_data ? offer.fnb_group_data : []
            }
            if(FNB_Criteria.length > 0) {
            text += " Also Get" + FNB_Criteria.map(y => y.oc_buy_no_of_item + "x -" + y.selectedFnbItem.item_name + " @ " + this.currFormat(y.oc_fnb_at_price) + " Each.").join(", ")
            }
          } 
        }
        return text;
      } else if(offer.offer_type_id == 10) {
        if(moreInfo) {
          let offerCondition = offer.oc_max_no_of_ticket_per_transaction || '';
          if(offerCondition) {
            text += `Max Apply limit ${offerCondition}`
          }
        } else {
          text += `Buy ${offer.oc_buy_no_of_ticket} Ticket and Get ${offer.oc_discount_value_is_percentage == 'Y' ? '' : 'Flat'} ${offer.oc_discount_value} ${offer.oc_discount_value_is_percentage == 'Y' ? '%' : ''} OFF on another ticket.`
          return text;
        }
      }
    },
    onSaveComboChanges() {
      let errorCount = 0;
      let errMsg = "";
      let finalComboPack = [];
      this.ComboPackArray.forEach((category, categoryIndex) => {
        let checkQuantity = 0;
        let categoryQty = category.quantity;
        category.combo_items.forEach(items => {
          checkQuantity += items.quantity;
          if (items.quantity > 0) {
            finalComboPack.push(items);
          }
        });
        if (checkQuantity != categoryQty) {
          errorCount++;
          errMsg = `Please Select ${parseInt(
            categoryQty - checkQuantity
          )} more Item for ${category.category_name} category`;
        }
      });

      if (errorCount > 0) {
        this.$toasted.show(errMsg);
        return false;
      } else {
        this.updateComboPack({
          orderIndex: this.SelectedComboIndex,
          finalComboPack: finalComboPack,
          combo_pack: this.ComboPackArray
        });

        this.$refs.comboPackModal.hide();
      }
    },
    getComboItemSelectedByCategory(categoryIndex) {
      let totalCount = 0;
      this.ComboPackArray[categoryIndex].combo_items.forEach(x => {
        totalCount += x.quantity;
      });
      return totalCount;
    },
    onChangeComboItems(food, index, category, categoryindex, type) {
      let totalItemSelected = this.getComboItemSelectedByCategory(
        categoryindex
      );
      if (type == "add") {
        if (totalItemSelected >= category.quantity) {
          this.$toasted.show("All items Selected for this category");
        } else {
          this.ComboPackArray[categoryindex].combo_items[index].quantity++;
        }
      } else if (type == "minus") {
        if (
          this.ComboPackArray[categoryindex].combo_items[index].quantity > 0
        ) {
          this.ComboPackArray[categoryindex].combo_items[index].quantity--;
        }
      }
    },
    getComboAlternateItems(category) {
      let itemArray = [];

      category.selected_items.forEach(x => {
        let itemObj = {
          item_id: x.item_id,
          item_name: x.item_name,
          item_image_url: x.item_image_url,
          quantity: x.quantity,
          category_id: category.category_id,
          fc_bgColor: category.fc_bgColor,
          fc_fontColor: category.fc_fontColor,
          category_name: category.category_name,
          selected: x.quantity > 0 ? true : false
        };
        itemArray.push(itemObj);
      });

      category.alternate_items.forEach(y => {
        let itemObj = {
          item_id: y.item_id,
          item_name: y.item_name,
          item_image_url: y.item_image_url,
          fc_bgColor: category.fc_bgColor,
          fc_fontColor: category.fc_fontColor,
          quantity: 0,
          category_id: category.category_id,
          category_name: category.category_name,
          selected: false
        };
        itemArray.push(itemObj);
      });

      return itemArray;
    },
    onCustomizeCombo(order, orderIndex) {
      this.ComboPackArray = [];
      if (order.hasOwnProperty("combo_pack") && order.combo_pack.length > 0) {
        this.SelectedComboIndex = orderIndex;
        this.ComboPackArray = _.cloneDeep(order.combo_pack);
        this.$refs.comboPackModal.show();
      }
    },
    onToggleAddonBreakup() {
      this.showAddonBreakup = !this.showAddonBreakup;
    },
    onClickInputHandler(event) {
      if (
        Object.keys(this.keyboardsVisible).some(
          x => this.keyboardsVisible[x] == true
        )
      ) {
        Object.keys(this.keyboardsVisible).map(x => {
          if (x == event) {
            this.keyboardsVisible[x] = !this.keyboardsVisible[x];
          } else {
            this.keyboardsVisible[x] = false;
          }
        });
      }
    },
    seatTimeout() {
      console.log("seat release time out toast from box office");
      this.$store.dispatch("MAKE_SEAT_BOOKING_DETAILS_EMPTY", {
        doNotShowError: false
      });
      this.$toasted.show("Seats Released");
      clearTimeout(this.seatReleasePopUp);
      clearTimeout(this.hideSeatExtendPopUp);
      clearTimeout(this.showSeatReleaseMsg);
      this.$bvModal.hide("extendSeatRelease");
      this.onSwitchToBoxOffice();
      this.$store.commit("SET_EMPTY_SEAT_BOOKING_DETAILS");
    },
    clearAllTimeouts() {
      clearTimeout(this.seatReleasePopUp);
      clearTimeout(this.hideSeatExtendPopUp);
      clearTimeout(this.showSeatReleaseMsg);
      this.$bvModal.hide("extendSeatRelease");
    },
    timeLeftTimer() {
      this.resetSeatReleaseIn();
      this.timeLeft = this.POS_SEAT_ALERT_TIME_IN_SEC;
      this.timerInterval = setInterval(() => {
        this.timePassed = this.timePassed += 1;
        this.timeLeft = this.POS_SEAT_ALERT_TIME_IN_SEC - this.timePassed;
        if (this.timeLeft == 0) {
          this.onTimesUp();
        }
        const minutes = Math.floor(this.timeLeft / 60);
        let seconds = this.timeLeft % 60;
        let minutes_n = minutes;
        if (seconds < 10) {
          seconds = `0${seconds}`;
        }
        if (minutes < 10) {
          minutes_n = `0${minutes}`;
        }
        this.seatReleaseIn = `${minutes_n}:${seconds}`;
      }, 1000);
    },
    resetSeatReleaseIn() {
      if (this.POS_SEAT_ALERT_TIME_IN_SEC) {
        const minutes = Math.floor(this.POS_SEAT_ALERT_TIME_IN_SEC / 60);
        let seconds = this.POS_SEAT_ALERT_TIME_IN_SEC % 60;
        let minutes_n = minutes;
        if (seconds < 10) {
          seconds = `0${seconds}`;
        }
        if (minutes < 10) {
          minutes_n = `0${minutes}`;
        }
        this.seatReleaseIn = `${minutes_n}:${seconds}`;
      } else {
        this.seatReleaseIn = `00:00`;
      }
    },
    onTimesUp() {
      this.timePassed = 0;
      this.timeLeft = 0;
      clearInterval(this.timerInterval);
    },
    onSwitchToBoxOffice: function() {
      let userInfo = this.secureStore.get("USINFO");
      if (userInfo) {
        userInfo["role_name"] = "POS Operator";

        this.secureStore.set("USINFO", userInfo);
        this.$router.push({
          path: "pos-booking"
        });
      } else {
        this.$router.push({
          path: "pos-login"
        });
      }
      this.$store.dispatch("onResetFnBStoreState");
    },
    onShowSeatReleasePopUp() {
      if (this.POS_SEAT_ALERT_TIME_IN_SEC) {
        this.hideSeatExtendPopUp = setTimeout(() => {
          this.$bvModal.hide("extendSeatRelease");
        }, this.POS_SEAT_ALERT_TIME_IN_SEC * 1000);
      }
    },
    onHideSeatReleasePopUp() {
      clearTimeout(this.hideSeatExtendPopUp);
    },
    handleExtendSeatRelease() {
      let payload = {
        reservation_id: this.reservationId
      };
      MasterService.ExtendSeatReleaseTime(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.$bvModal.hide("extendSeatRelease");
            this.resetReleaseSeatPopUpTimer();
          } else {
            console.log("No status");
          }
        })
        .catch(err => {
          console.log("Error:", err);
        });
    },
    resetReleaseSeatPopUpTimer() {
      clearTimeout(this.seatReleasePopUp);
      clearTimeout(this.showSeatReleaseMsg);
      if (this.POS_SEAT_EXTEND_TIMER && this.POS_SEAT_EXTEND_TIMER > 0) {
        this.seatReleasePopUp = setTimeout(() => {
          this.timeLeftTimer();
          if (this.showSeatExtendPopUp) {
            console.log("line 1906 TEST extendSeatRelease called");
            this.$bvModal.show("extendSeatRelease");
          }
        }, this.POS_SEAT_EXTEND_TIMER);
      }

      if (
        this.CINE_SEAT_RELEASE_TIME_IN_MINS &&
        this.CINE_SEAT_RELEASE_TIME_IN_MINS > 0
      ) {
        this.showSeatReleaseMsg = setTimeout(() => {
          console.log("Seat relase message timeout");
          this.seatTimeout();
        }, this.CINE_SEAT_RELEASE_TIME_IN_MINS * 60 * 1000);
      }
    },
    onRemoveCashCard() {
      this.resetCashCardData();
      this.resetCustomerDetails();
    },
    clearVoucherCode() {
      this.voucherCodeValue = "";
    },
    checkVoucherDetails(OffersVoucherItem) {
      if (OffersVoucherItem.is_code_required == "N") {
        let voucherCode = {
          target: {
            value: OffersVoucherItem.voucher_code
          }
        };
        this.onEnterVoucherCode({
          event: voucherCode,
          name: "enterVoucherCode"
        });
        this.applyBoxOfficeFnbOffersHandler({
          event: null,
          offer: OffersVoucherItem,
          offerFor: "BoxOfficeFnbVouchers"
        });
      } else {
        this.OffersItem = OffersVoucherItem;
        this.$refs["verifyBOXFNBVoucher"].show();
      }
    },
    onClickCall: function(name) {
      if (name == "Refresh") {
        this.$store.dispatch("onResetFnBHandler", {doNotFetchFnb: true});
        this.$store.dispatch("onResetFnBStoreState");
        this.$store.dispatch("CHANGE_FLAG_ShowViewOffers", false);
        this.$store.dispatch("onRemoveFnBList");
        this.$store.dispatch("releaseRealtimeSeats");
        this.$store.dispatch("MAKE_SEAT_BOOKING_DETAILS_EMPTY");
        this.clearAllTimeouts();
        let cinemaId = null;
        let userDetails = null;
        if (this.secureStore.get("USINFO")) {
          cinemaId =
            this.secureStore.get("USINFO") &&
            this.secureStore.get("USINFO")["cinema_id"]
              ? this.secureStore.get("USINFO").cinema_id
              : null;
          userDetails =
            this.secureStore.get("USINFO").first_name +
            " " +
            this.secureStore.get("USINFO").last_name;
        }
        let stockDeduction = this.secureStore.get("BRGLOPSTDE")
          ? this.secureStore.get("BRGLOPSTDE")
          : null;
        let stockDeductionConcession = this.secureStore.get("BRGLOPSTDECO")
          ? this.secureStore.get("BRGLOPSTDECO")
          : null;

        this.SetCinemaId({
          cinemaId,
          userDetails,
          stockDeduction,
          stockDeductionConcession
        });
        // this.fetchCalculatorCash();
        // this.fetchFnBItems();
        // this.fetchFnBCategories({cinema_id: cinemaId});
        this.fetchCurrencyCode({ curr_id: this.secureStore.get("BRGLOPCUR") });
        this.fetchCinemaDetails(cinemaId);
      } else {
        Object.keys(this.childComponents).map(x => {
          if (x == name) {
            this.childComponents[x] = !this.childComponents[x];
          } else {
            this.childComponents[x] = false;
          }
        });
        if (this.PosMultiFnbFlag && !this.childComponents.PosMultiFnB) {
          this.childComponents.PosMultiFnB = true;
        }
      }
    },
    onEmitSocket: function() {
      if (this.$socket) {
        setTimeout(() => {
          let charges = this.AdditionalTaxList;
          this.$socket.emit("main_brij_FnB_flag_change", {
            flag: true,
            fnbItems: this.SelectedFnbItemList,
            curr_code: this.getFnBCurrency.curr_code,
            charges: charges
          });
        }, 2000);

        // this.$socket.emit("main_brij_FnB_flag_change", {
        //   flag: true,
        //   fnbItems: this.SelectedFnbItemList
        // });
      }
    },
    goToTop() {
      setTimeout(() => {
        var elmnt = document.getElementById("myDiv");
        elmnt.scrollIntoView();
      }, 200);
    },
    // saif
    ...mapActions([
      "resetMeritCardDetails",
      "fetchFnbStations",
      "onAddFnBList",
      "onBackFnBHandler",
      "updateComboPack",
      "resetCashCardData",
      "resetCustomerDetails",
      "fetchOffersList",
      "fetchCinemaDetails",
      "fetchCalculatorCash",
      "fetchFnBItems",
      "setOnFnBPayloads",
      "fetchFnBCategories",
      "fetchCurrencyCode",
      "onRemoveFnBList",
      "onIncreaseFnBItem",
      "onDecreaseFnBItem",
      "SetCinemaId",
      "onIsVegChange",
      "onSwtichModule",
      "OnPhoneNumberSubmitHandler",
      "applyFnbOffersHandler",
      "onEnterVoucherCode",
      "onInputComment",
      "applyOffersHandler",
      "GoToRoute",

      "applyBoxOfficeFnbOffersHandler",
      "onResetOffersAndPrice",
      "onEnterPromoCodes",
      //
      "resetLoyaltyData",
      //Addon
      "onDecreaseAddonItem",
      "onIncreaseAddonItem",
      "onRemoveAddonList",
      "setFnbPosFooterMenus",
      //alternate
      "onFetchAlternateItems",
      "onReplaceAlternateItem",
      "onSelectCustomization",
      "onFetchCustomization",
      "onRemoveCustomization",
      "onResetEmployeeDetails"
    ]),
    // Saif
    closeApplicableOffersModal: function() {
      this.$refs["applicable-offer-modal"].hide();
    },
    onClickAddOnButton: async function() {
      await this.$store.dispatch("fetchAddonsList");
    }
    // onApplyOffer: function(offer) {
    //   if (offer.oc_is_combo == "Y" && offer.oc_is_combo_with_fnb == "Y") {
    //     console.log("offer :", offer, this.SelectedFnbItemList);
    //     this.OffersFnbItems.map(x => {
    //       if (
    //         x.item_id == offer.oc_buy_item_id &&
    //         x.quantity >= offer.oc_buy_item_count
    //       ) {
    //         this.OffersFnbItems.map(y => {
    //           if (
    //             y.item_id == offer.oc_get_item_id &&
    //             y.quantity >= offer.oc_get_item_count
    //           ) {
    //             console.log("x.item_id :", x.item_id);
    //             console.log("x.quantity :", x.quantity);
    //             this.$refs["applicable-offer-modal"].hide();
    //             this.$store.dispatch("SET_FNB_TOTAL_PRICE", offer);
    //           }
    //         });
    //       } else {
    //         this.$refs["applicable-offer-modal"].hide();
    //       }
    //     });
    //   }
    // }
  }
};
</script>
<style>
.category-title {
  font-size: 16px;
  text-transform: capitalize;
  font-style: italic;
  font-weight: 500;
}

.category-title-box {
  border-radius: 10px;
  padding: 5px;
  margin-bottom: 5px;
  -webkit-box-shadow: 0 1px 5px 0px lightgrey;
  box-shadow: 0px 1px 1px 0px lightgrey;
}

.combo-item-name {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 12px;
}

.combo-food-card {
  width: 80%;
  height: 170px;
  overflow: hidden;
  position: relative;
  border-radius: var(--posFnbGlobalRadius);
  background-color: #fff;
  box-shadow: 4px 5px 12px -7px;
}

.combo-food-card .food-img {
  width: 100%;
  display: flex;
  align-items: center;
  overflow: hidden;
  text-align: center;
  justify-content: center;
  height: calc(100% - 75px);
}

.combo-food-card .food-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.combo-detail-card {
  left: 0;
  bottom: 0;
  width: 100%;
  height: 80px;
  padding: 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  text-align: center;
  position: absolute;
  background-color: var(--lightblue);
}

.combo-btn-style {
  color: black;
  box-shadow: 1px 3px 10px 1px #817a7a;
  border: none;
  background: white !important;
}

.activeComboItems {
  box-shadow: 0px 10px 19px -2px rgb(56 59 53);
  transform: scale(1.1);
}

.br-20 {
  border-radius: 20px !important;
}

.combo-item-count {
  color: green;
  font-weight: bold;
}

.newCard {
  height: 125px;
  overflow: hidden;
  box-shadow: 0px 5px 10px -4px;
  border-radius: 10px;
  margin: -3px;
}

.selectedComboItem-sm {
  position: absolute;
  left: 90%;
  top: 0%;
  border-radius: 50%;
  height: 28px;
  width: 28px;
  background: white;
}

.selectedComboItem {
  position: relative;
  left: 85%;
  top: -98%;
  border-radius: 50%;
  height: 28px;
  width: 28px;
  background: white;
}

.product-name {
  font-weight: bold;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 40px;
}
.position-parent {
  position: relative;
}
.position-child {
  position: absolute;
  bottom: 0;
}
@media screen and (min-width:1020px) and (max-width:1250px) {
  .newCard {
    height: 150px;
      /* overflow: hidden;
      box-shadow: 0px 5px 10px -4px;
      border-radius: 10px;
      margin: -3px;
      transition: 0.2s all; */
  }
  .font_size_12{
    font-size: 11px !important;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Pages/BoxOfficeFnbContainer/boxOfficeFnb.vue